<template>
  <q-banner v-if="retencao && retencao.deduz" dense class="bg-grey-3">
    <template v-slot:avatar>
      <q-icon color="primary" name="info" />
    </template>
    Cliente com ISS retido pelo tomador ({{ aliquota }}%):
    {{ parcela ? "cada parcela" : "a cobrança" }} sai com
    <strong>R$ {{ $currency(retencao.valor_cobranca) }}</strong>
    (R$ {{ $currency(retencao.valor_bruto) }} − ISS de R$ {{ $currency(retencao.valor_iss) }}).
  </q-banner>
</template>

<script>
import axios from "@/axios-auth";
import { debounce } from "quasar";

/**
 * Mostra quanto sai na cobrança de uma receita nova de cliente com ISS retido. A conta é do back
 * (GET /financeiro/retencao-iss), a mesma que ele faz ao salvar: o aviso nunca diverge do que vai
 * ser cobrado.
 */
export default {
  name: "aviso-retencao-iss",
  props: {
    cadastroId: [Number, String],
    // Valor bruto, antes do ISS
    valor: [Number, String],
    parcela: Boolean,
  },
  data() {
    return {
      retencao: null,
    };
  },
  computed: {
    consulta() {
      return [this.cadastroId, this.valor].join("|");
    },
    aliquota() {
      return Number(this.retencao.aliquota).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  watch: {
    consulta() {
      this.consultarComAtraso();
    },
  },
  created() {
    this.pedidos = 0;
    this.consultarComAtraso = debounce(this.consultar, 400);
  },
  mounted() {
    this.consultar();
  },
  methods: {
    async consultar() {
      const valor = Number(this.valor);
      const pedido = ++this.pedidos;

      if (!this.cadastroId || !(valor > 0)) {
        this.retencao = null;
        return;
      }

      const res = await axios.get("/financeiro/retencao-iss", {
        params: { cadastro_id: this.cadastroId, valor },
      });

      // Digitando o valor, uma resposta antiga pode chegar depois da nova.
      if (pedido !== this.pedidos) {
        return;
      }

      // Sem a prévia a tela segue como antes; quem decide o valor é o back ao salvar.
      this.retencao = res.error || !res.data || !res.data.success ? null : res.data.data;
    },
  },
};
</script>
